/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
*/

import type { SVGProps } from 'react'

// Untitled UI Icons — "link-01" (Line variant). Two interlocking chain
// segments rendered as stroked paths so colour + stroke-width follow the
// surrounding text (matches the `Inbox`/`ArrowLeft` pattern in this folder).
const Link = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.586 13.414a2 2 0 0 0 2.828 0l4.243-4.243a4 4 0 0 0-5.657-5.657l-.707.707" />
    <path d="M13.414 10.586a2 2 0 0 0-2.828 0l-4.243 4.243a4 4 0 0 0 5.657 5.657l.707-.707" />
  </svg>
)

export default Link
